/**
 * Cart Upsell — single lifecycle for Free Shipping + Related Products + Quick Add.
 * Cart Page and Cart Drawer share this module (no duplicate page/drawer bundles).
 *
 * Integrates with theme pubsub (PUB_SUB_EVENTS.cartUpdate).
 * - No fetch monkey-patch
 * - No setInterval /cart.js polling
 * - Document-level event delegation (safe across section re-renders)
 * - Once-only init guard
 */
(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  var SOURCE = 'cart-upsell';
  var inFlight = new Set();
  var footerRefreshTimer = null;

  function strings() {
    return (
      window.cartUpsellStrings || {
        addToCart: 'Add to cart',
        chooseOptions: 'Choose options',
        adding: 'Adding...',
        added: 'Added to cart',
        error: 'Could not add item',
        viewProduct: 'View',
      }
    );
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.theme && theme.moneyFormat);
      }
    } catch (e) {
      /* ignore */
    }
    var amount = Number(cents) || 0;
    return '¥' + amount.toLocaleString('ja-JP');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function loadRecommendationFallbacks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll('[data-cart-related-fallback]')
      : [];

    Array.prototype.forEach.call(sections, function (section) {
      if (section.getAttribute('data-fallback-loaded') === 'true') return;

      var productId = section.getAttribute('data-product-id');
      var limit = parseInt(section.getAttribute('data-limit') || '4', 10) || 4;
      var hideSoldOut = section.getAttribute('data-hide-sold-out') === 'true';
      var cartIds = section.getAttribute('data-cart-product-ids') || ',';
      var track = section.querySelector('[data-cart-related-fallback-track]');
      if (!productId || !track) return;

      section.setAttribute('data-fallback-loaded', 'true');

      var rootPath =
        (window.Shopify && Shopify.routes && Shopify.routes.root) ||
        (window.routes && routes.root) ||
        '/';
      var url =
        rootPath +
        'recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        encodeURIComponent(String(Math.min(limit + 4, 10))) +
        '&intent=related';

      fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          var html = '';
          var count = 0;
          var viewLabel = strings().viewProduct;

          products.forEach(function (product) {
            if (count >= limit || !product) return;
            var token = ',' + product.id + ',';
            if (cartIds.indexOf(token) !== -1) return;
            if (hideSoldOut && product.available === false) return;

            var title = escapeHtml(product.title || '');
            var urlPath = escapeHtml(product.url || '#');
            var image =
              product.featured_image ||
              (product.images && product.images[0]) ||
              '';
            var imageHtml = image
              ? '<img class="cart-upsell-product__image" src="' +
                escapeHtml(image) +
                '" alt="' +
                title +
                '" loading="lazy" width="240" height="240">'
              : '';
            var priceHtml = formatMoney(product.price);
            var compareHtml = '';
            if (
              product.compare_at_price &&
              Number(product.compare_at_price) > Number(product.price)
            ) {
              compareHtml =
                ' <s>' + formatMoney(product.compare_at_price) + '</s>';
            }

            html +=
              '<article class="cart-upsell-product" role="listitem" data-product-id="' +
              escapeHtml(product.id) +
              '">' +
              '<a href="' +
              urlPath +
              '" class="cart-upsell-product__media" aria-label="' +
              title +
              '">' +
              imageHtml +
              '</a>' +
              '<div class="cart-upsell-product__info">' +
              '<a href="' +
              urlPath +
              '" class="cart-upsell-product__title link-styled">' +
              title +
              '</a>' +
              '<div class="cart-upsell-product__price">' +
              priceHtml +
              compareHtml +
              '</div>' +
              '<div class="cart-upsell-product__actions">' +
              '<a href="' +
              urlPath +
              '" class="cart-upsell-product__view button button--secondary button--full-width" aria-label="' +
              escapeHtml(viewLabel) +
              ' — ' +
              title +
              '">' +
              escapeHtml(viewLabel) +
              '</a>' +
              '</div></div></article>';
            count += 1;
          });

          if (!count) return;
          track.innerHTML = html;
          section.hidden = false;
        })
        .catch(function (err) {
          console.error('cart-upsell recommendation fallback failed', err);
          section.removeAttribute('data-fallback-loaded');
        });
    });
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = selector ? doc.querySelector(selector) : doc.querySelector('.shopify-section') || doc.body;
    return el ? el.innerHTML : '';
  }

  function getSectionsToRender() {
    var sections = [];

    var cartItemsEl = document.getElementById('main-cart-items');
    if (cartItemsEl && cartItemsEl.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: cartItemsEl.dataset.id,
        selector: '.js-contents',
      });
    }

    var cartFooterEl = document.getElementById('main-cart-footer');
    if (cartFooterEl && cartFooterEl.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: cartFooterEl.dataset.id,
        selector: '.js-contents',
      });
    }

    if (document.getElementById('cart-icon-bubble')) {
      sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      });
    }

    if (document.getElementById('cart-live-region-text')) {
      sections.push({
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      });
    }

    if (document.querySelector('cart-drawer')) {
      sections.push({
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      });
    }

    return sections;
  }

  /* ---------- Free shipping bar animation ---------- */

  function animateFreeShippingBars(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-free-shipping-progress]');

    if ((!nodes || !nodes.length) && scope.matches && scope.matches('[data-free-shipping-progress]')) {
      nodes = [scope];
    }

    Array.prototype.forEach.call(nodes, function (el) {
      var track = el.querySelector('[data-progress-track], .cart-free-shipping__track');
      if (!track) return;

      var raw = parseFloat(el.getAttribute('data-progress') || '0', 10);
      if (isNaN(raw) || raw < 0) raw = 0;
      if (raw > 100) raw = 100;

      // Paint fill on the track (no child bar). Survives stale CSS that used scaleX(0).
      var fill = el.classList.contains('cart-free-shipping--qualified') ? '#000000' : '#111111';
      var rest = '#e5e5e5';
      track.style.setProperty('display', 'block', 'important');
      track.style.setProperty('height', '24px', 'important');
      track.style.setProperty('min-height', '24px', 'important');
      track.style.setProperty(
        'background-image',
        'linear-gradient(to right, ' +
          fill +
          ' 0%, ' +
          fill +
          ' ' +
          raw +
          '%, ' +
          rest +
          ' ' +
          raw +
          '%, ' +
          rest +
          ' 100%)',
        'important'
      );
      track.style.setProperty('background-color', rest, 'important');
    });
  }

  function scheduleAnimateBars(root) {
    requestAnimationFrame(function () {
      animateFreeShippingBars(root || document);
    });
  }

  /* ---------- A11y ---------- */

  function announce(message) {
    if (!message) return;
    document.querySelectorAll('[data-cart-upsell-live-region]').forEach(function (region) {
      region.textContent = '';
      requestAnimationFrame(function () {
        region.textContent = message;
      });
    });

    var cartLive = document.getElementById('cart-live-region-text');
    if (cartLive) cartLive.textContent = message;
    var drawerLive = document.getElementById('CartDrawer-LiveRegionText');
    if (drawerLive) drawerLive.textContent = message;
  }

  function showButtonError(button, message) {
    var card = button && button.closest('.cart-upsell-product');
    var errorEl = card && card.querySelector('[data-cart-upsell-error]');
    if (!errorEl) {
      announce(message);
      return;
    }
    errorEl.hidden = false;
    errorEl.textContent = message;
    announce(message);
  }

  function clearButtonError(button) {
    var card = button && button.closest('.cart-upsell-product');
    var errorEl = card && card.querySelector('[data-cart-upsell-error]');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  /* ---------- Section paint ---------- */

  function replaceSections(sectionsHtml, sectionDefs) {
    if (!sectionsHtml || !sectionDefs) return;

    var drawer = document.querySelector('cart-drawer');
    var drawerWasOpen = !!(drawer && drawer.classList.contains('active'));

    sectionDefs.forEach(function (section) {
      var html = sectionsHtml[section.section];
      if (!html) return;

      try {
        if (section.id === 'main-cart-items') {
          var cartItems = document.querySelector('cart-items');
          var srcItems = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
          if (cartItems && srcItems) cartItems.innerHTML = srcItems.innerHTML;
          return;
        }

        if (section.id === 'cart-drawer') {
          var drawerInner = document.querySelector('#CartDrawer');
          if (!drawerInner) return;
          drawerInner.innerHTML = getSectionInnerHTML(html, '#CartDrawer');
          var overlay = document.querySelector('#CartDrawer-Overlay');
          if (overlay && drawer) {
            overlay.addEventListener('click', drawer.close.bind(drawer));
          }
          return;
        }

        var root = document.getElementById(section.id);
        if (!root) return;
        var target = (section.selector && root.querySelector(section.selector)) || root;
        var content = getSectionInnerHTML(html, section.selector);
        if (target) target.innerHTML = content;
      } catch (err) {
        console.error('cart-upsell section replace failed', section.id, err);
      }
    });

    if (drawerWasOpen && drawer) {
      drawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }

    scheduleAnimateBars(document);
  }

  function syncEmptyState(itemCount) {
    var empty = !itemCount;
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.classList.toggle('is-empty', empty);
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', empty);
    var cartItemsRoot = document.querySelector('cart-items');
    if (cartItemsRoot) cartItemsRoot.classList.toggle('is-empty', empty);
  }

  function setLoading(button, isLoading) {
    if (!button) return;
    var label = button.querySelector('.cart-upsell-product__add-label');
    var loadingLabel = button.querySelector('.cart-upsell-product__add-loading');
    var spinner = button.querySelector('.loading__spinner');
    button.classList.toggle('loading', isLoading);
    button.disabled = isLoading;
    button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
    if (label) label.classList.toggle('hidden', isLoading);
    if (loadingLabel) {
      loadingLabel.classList.toggle('hidden', !isLoading);
      loadingLabel.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
    }
  }

  /* ---------- Footer bridge (product-form / notification paths) ---------- */

  function refreshMainCartFooter() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer || !footer.dataset.id) return Promise.resolve();

    return fetch(routes.cart_url + '?section_id=' + encodeURIComponent(footer.dataset.id))
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var jsContents = footer.querySelector('.js-contents');
        if (!jsContents) return;
        var nextHtml = getSectionInnerHTML(responseText, '.js-contents');
        // Never wipe subtotal / free-shipping if section parse failed
        if (!nextHtml) return;
        jsContents.innerHTML = nextHtml;
        scheduleAnimateBars(footer);
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  function scheduleFooterRefresh() {
    // Debounce: product-form + cart-items subscribers can fire close together
    if (footerRefreshTimer) clearTimeout(footerRefreshTimer);
    footerRefreshTimer = setTimeout(function () {
      footerRefreshTimer = null;
      refreshMainCartFooter();
    }, 0);
  }

  function sourceNeedsFooterBridge(source) {
    // These paths already paint main-cart-footer via Section Rendering in the same request
    if (!source || source === SOURCE || source === 'cart-items') return false;
    // product-form / cart-notification / quick-add / others: line items may refresh via
    // CartItems.onCartUpdate, but footer (subtotal + free shipping) often does not.
    return !!document.getElementById('main-cart-footer');
  }

  /* ---------- Quick add (single variant) ---------- */

  async function addVariant(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (inFlight.has(variantId)) return;

    inFlight.add(variantId);
    clearButtonError(button);
    setLoading(button, true);
    var sectionDefs = getSectionsToRender();

    try {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append(
        'sections',
        sectionDefs
          .map(function (s) {
            return s.section;
          })
          .join(',')
      );
      formData.append('sections_url', window.location.pathname);

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      var res = await fetch(routes.cart_add_url, config);
      var data = await res.json().catch(function () {
        return null;
      });

      if (!res.ok || !data || data.status) {
        throw new Error((data && (data.description || data.message)) || strings().error);
      }

      replaceSections(data.sections, sectionDefs);
      syncEmptyState(data.item_count);
      announce(strings().added);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: SOURCE,
            productVariantId: variantId,
            cartData: data,
          });
        } catch (publishErr) {
          console.error(publishErr);
        }
      }
    } catch (err) {
      console.error(err);
      var message = (err && err.message) || strings().error;
      if (document.contains(button)) {
        showButtonError(button, message);
      } else {
        announce(message);
      }
    } finally {
      inFlight.delete(variantId);
      if (document.contains(button) && button.classList.contains('loading')) {
        setLoading(button, false);
      }
    }
  }

  /* ---------- Event wiring (once) ---------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addVariant(button);
  });

  document.addEventListener('keydown', function (event) {
    var scroller = event.target.closest('[data-cart-related-scroller]');
    if (!scroller) return;

    var track = scroller.querySelector('.cart-related-products__track');
    if (!track || track.scrollWidth <= track.clientWidth) return;

    var step = Math.max(120, Math.floor(track.clientWidth * 0.8));
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      track.scrollBy({ left: step, behavior: 'smooth' });
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      track.scrollBy({ left: -step, behavior: 'smooth' });
    } else if (event.key === 'Home') {
      event.preventDefault();
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (event.key === 'End') {
      event.preventDefault();
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var source = event && event.source;

      // Theme section paint first, then animate progress bars / optional fallback
      setTimeout(function () {
        scheduleAnimateBars(document);
        loadRecommendationFallbacks(document);
      }, 0);

      if (sourceNeedsFooterBridge(source)) {
        scheduleFooterRefresh();
      }

      // Modal / PDP ATC success while upsell UI is present
      if (source === 'product-form' && document.querySelector('[data-cart-related-products]')) {
        announce(strings().added);
      }
    });
  }

  // bfcache restore: re-run bar animation only (no /cart.js poll)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      scheduleAnimateBars(document);
      loadRecommendationFallbacks(document);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleAnimateBars(document);
      loadRecommendationFallbacks(document);
    });
  } else {
    scheduleAnimateBars(document);
    loadRecommendationFallbacks(document);
  }

  // Public hook for debugging / future extensions
  window.CartUpsell = {
    source: SOURCE,
    getSectionsToRender: getSectionsToRender,
    animateFreeShippingBars: animateFreeShippingBars,
    refreshMainCartFooter: refreshMainCartFooter,
    loadRecommendationFallbacks: loadRecommendationFallbacks,
  };
})();
